<ng-container *ngIf="step === 0; else checkMode" [ngTemplateOutlet]="editMode">
</ng-container>

<ng-template #editMode>
    <ng-container *ngIf="!stopRendering else loading">
        <form [formGroup]="profileForm" class="prsform">
            <!--Reiseanmelder wrapper-->
            <div class="inputswrapper">
                <!--Info Reiseanmelder data-->
                <div class="anmeldername">

                    <!--Anrede-->
                    <div class="anrede">
                        <div>
                            <mat-button-toggle-group formControlName="anmelder_anrede"
                                [class.mat-form-field-invalid]="!profileForm.controls['anmelder_anrede'].valid && profileForm.controls['anmelder_anrede'].touched">
                                <mat-button-toggle multilang value="Herr"
                                    [style.background]="profileForm.controls['anmelder_anrede'].touched ? '': 'transparent'"
                                    [style.color]="!profileForm.controls['anmelder_anrede'].valid && profileForm.controls['anmelder_anrede'].touched ? 'red' : ''">
                                    Herr
                                </mat-button-toggle>
                                <mat-button-toggle multilang value="Frau"
                                    [style.background]="profileForm.controls['anmelder_anrede'].touched ? '': 'transparent'"
                                    [style.color]="!profileForm.controls['anmelder_anrede'].valid && profileForm.controls['anmelder_anrede'].touched ? 'red' : ''">
                                    Frau
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                            <span multilang style="margin-left: .5rem;">*</span>
                        </div>
                        <mat-error multilang
                            *ngIf="!profileForm.controls['anmelder_anrede'].valid && profileForm.controls['anmelder_anrede'].touched">
                            Anrede (Pflichtfeld)</mat-error>
                    </div>

                    <div class="block">
                        <mat-form-field appearance="fill" style="width: 49%;">
                            <mat-label multilang>Vorname</mat-label>
                            <input matInput multilang deeplMode='placeholder' placeholder="Vorname"
                                name="anmelder_vorname" formControlName="anmelder_vorname" required>
                            <mat-error multilang>Vorname (Pflichtfeld)</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="fill" color="primary" style="width: 50%;">
                            <mat-label multilang>Nachname</mat-label>
                            <input matInput multilang deeplMode='placeholder' placeholder="Nachname"
                                name="anmelder_name" formControlName="anmelder_name" required>
                            <mat-error multilang>Nachname (Pflichtfeld)</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="block">
                        <mat-form-field appearance="fill" color="primary" style="width: 32%;">
                            <mat-select required formControlName="anmelder_geburtstag">
                                <mat-option value="">TT</mat-option>
                                <mat-option *ngFor="let gt of geburtstagdata" [value]="gt">{{gt}}</mat-option>
                            </mat-select>
                            <mat-label multilang>Geburtstag</mat-label>
                            <mat-error multilang>Geburtstag (Pflichtfeld)</mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="fill" color="primary" style="width: 32%;">
                            <mat-select required formControlName="anmelder_monat">
                                <mat-option value="">MM</mat-option>
                                <mat-option *ngFor="let gt of monatdata" [value]="gt">{{gt}}</mat-option>
                            </mat-select>
                            <mat-label multilang>Monat</mat-label>
                            <mat-error multilang>Monat (Pflichtfeld)</mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="fill" color="primary" style="width: 32%;">
                            <mat-select required formControlName="anmelder_jahr">
                                <mat-option value="">JJJJ</mat-option>
                                <mat-option *ngFor="let gt of jahrdata; trackBy: trackByFnC" [value]="gt">
                                    {{gt}}</mat-option>
                            </mat-select>
                            <mat-label multilang>Jahr</mat-label>
                            <mat-error multilang>Jahr (Pflichtfeld)</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="block">
                        <mat-form-field appearance="fill" color="primary" style="width: 66%;">
                            <mat-label multilang>Straße</mat-label>
                            <input matInput multilang deeplMode='placeholder' placeholder="Straße"
                                name="anmelder_strasse" formControlName="anmelder_strasse" required>
                            <mat-error multilang>Straße (Pflichtfeld)</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="fill" color="primary" style="width: 33%;">
                            <mat-label multilang>Hausnummer</mat-label>
                            <input matInput multilang deeplMode='placeholder' placeholder="Hausnummer"
                                name="anmelder_hausnummer" formControlName="anmelder_hausnummer" required>
                            <mat-error multilang>Hausnummer (Pflichtfeld)</mat-error>
                        </mat-form-field>
                    </div>

                </div>

                <div class="block">
                    <mat-form-field appearance="fill" color="primary" style="width: 32%;">
                        <mat-label multilang>PLZ</mat-label>
                        <input matInput multilang deeplMode='placeholder' placeholder="PLZ" name="anmelder_plz"
                            formControlName="anmelder_plz" required>
                        <mat-error multilang>PLZ (Pflichtfeld)</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="fill" color="primary" style="width: 33%;">
                        <mat-label multilang>Ort</mat-label>
                        <input matInput multilang deeplMode='placeholder' placeholder="Ort" name="anmelder_wohnort"
                            formControlName="anmelder_wohnort" required>
                        <mat-error multilang>Ort (Pflichtfeld)</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="fill" color="primary" style="width: 33%;">
                        <mat-select required name="anmelder_land" formControlName="anmelder_land"
                            (selectionChange)="changeCountry($event)">
                            <mat-option [value]="'de'">Deutschland</mat-option>
                            <mat-option [value]="'at'">Österreich</mat-option>
                            <mat-option [value]="'ch'">Schweiz</mat-option>
                            <mat-divider></mat-divider>
                            <mat-option *ngFor="let co of countryList; trackBy: trackByFn" [value]="co.code">{{co.name}}
                            </mat-option>
                        </mat-select>
                        <mat-label multilang>Land</mat-label>
                        <mat-error multilang>Land (Pflichtfeld)</mat-error>
                    </mat-form-field>
                </div>

                <!--anmelder_telefon-->
                <div style="display: flex;">
                    <mat-form-field appearance="fill" color="primary">
                        <mat-label multilang>Handynummer für Notfall</mat-label>
                        <input matInput multilang deeplMode='placeholder' placeholder="Handynummer"
                            name="anmelder_telefon" formControlName="anmelder_telefon" required>
                        <mat-error multilang>Handynummer (Pflichtfeld)</mat-error>
                    </mat-form-field>
                </div>
                <!--end anmelder_telefon-->

                <!--E-Mail-Adresse-->
                <div style="display: flex;">
                    <mat-form-field appearance="fill" color="primary">
                        <mat-label multilang>E-Mail-Adresse</mat-label>
                        <input matInput multilang deeplMode='placeholder' placeholder="E-Mail-Adresse"
                            name="anmelder_email" formControlName="anmelder_email" required>
                        <mat-error multilang>E-Mail-Adresse (Pflichtfeld)</mat-error>
                    </mat-form-field>
                </div>
                <div style="display: flex;">
                    <mat-form-field appearance="fill">
                        <mat-label multilang>Anmerkungen (maximal 600 Zeichen)</mat-label>
                        <textarea matInput formControlName="anmelder_text" rows="10" maxlength="600"></textarea>
                    </mat-form-field>
                </div>
                <span multilang style="padding-left: .5rem;">{{600 -
                    (profileForm?.controls?.['anmelder_text']?.value?.length > 0 ?
                    profileForm.controls['anmelder_text']?.value?.length : 0)}} Zeichen</span>
            </div>
        </form>
        <mat-divider></mat-divider>

        <form [formGroup]="travelersForm" class="prsform">
            <!--Reiseanmelder wrapper-->
            <div style="width: 100%;">

                <!--Reiseanmelder-->
                <div class="head-title mt">
                    <!--Title-->
                    <span multilang>
                        Personendaten
                    </span>
                    <!--end Title-->
                </div>
                <!--Info section-->
                <div class="mt mb5">

                    <span multilang>
                        Bitte teilen Sie uns die Reiseteilnehmer mit.
                        Die Namen des Reisenden müssen exakt mit dem amtlichen Lichtbildausweis übereinstimmen.
                    </span>
                </div>
                <!--end Info section-->

                <ng-container *ngFor="let prs of forms;let k=index">
                    <!--title-->
                    <div
                        style="display: flex;padding: .5rem;background-color: #d1e7dd;margin-left: -1rem;margin-right: -1rem;">
                        <span multilang>
                            Reiseteilnehmer {{k + 1}}.
                        </span>
                    </div>
                    <!--end title-->
                    <ng-template [ngIf]="k === 0">
                        <div style="display: flex;margin-top:1rem;">
                            <mat-checkbox color="primary" formControlName="fromKont" (change)="setDisabled($event)">
                                Ich nehme
                                selbst an der Kontakt.</mat-checkbox>
                        </div>
                    </ng-template>

                    <!--Anrede-->
                    <div style="display: flex;padding: .5rem 0;flex-direction: column;">
                        <div>
                            <mat-button-toggle-group [formControlName]="prs + '_anrede'"
                                [class.mat-form-field-invalid]="travelersForm.controls[prs + '_anrede'].invalid && (travelersForm.controls[prs + '_anrede'].touched || travelersForm.controls[prs + '_anrede'].disabled)">
                                <mat-button-toggle multilang value="Herr"
                                    [style.color]="travelersForm.controls[prs + '_anrede'].invalid && (travelersForm.controls[prs + '_anrede'].touched || travelersForm.controls[prs + '_anrede'].disabled) ? 'red' : ''">
                                    Herr
                                </mat-button-toggle>
                                <mat-button-toggle multilang value="Frau"
                                    [style.color]="travelersForm.controls[prs + '_anrede'].invalid && (travelersForm.controls[prs + '_anrede'].touched || travelersForm.controls[prs + '_anrede'].disabled) ? 'red' : ''">
                                    Frau
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                            <span multilang style="margin-left: .5rem;">*</span>
                        </div>
                        <mat-error multilang
                            *ngIf="travelersForm.controls[prs + '_anrede'].invalid && ((travelersForm.controls[prs + '_anrede'].touched || travelersForm.controls[prs + '_anrede'].disabled))">
                            Anrede (Pflichtfeld)</mat-error>
                    </div>
                    <!--end Anrede-->

                    <!--Vorname-->
                    <div style="display: flex;">
                        <mat-form-field appearance="fill">
                            <mat-label multilang>Vorname</mat-label>
                            <input matInput multilang deeplMode='placeholder' placeholder="Vorname"
                                name="{{prs + '_vorname'}}" formControlName="{{prs + '_vorname'}}" required>
                            <mat-error multilang>Vorname (Pflichtfeld)</mat-error>
                        </mat-form-field>
                    </div>
                    <!--end Vorname-->

                    <!--Nachname-->
                    <div style="display: flex;">
                        <mat-form-field appearance="fill" color="primary">
                            <mat-label multilang>Nachname</mat-label>
                            <input matInput multilang deeplMode='placeholder' placeholder="Nachname"
                                name="{{prs + '_name'}}" formControlName="{{prs + '_name'}}" required>
                            <mat-error multilang>Nachname (Pflichtfeld)</mat-error>
                        </mat-form-field>
                    </div>
                    <!--end Nachname-->

                    <!--Geburts-->
                    <div style="display: flex;justify-content: space-between;">
                        <!--Tag-->
                        <mat-form-field appearance="fill" color="primary" style="width: 32%;">
                            <mat-select required [formControlName]="prs + '_geburtstag'">
                                <mat-option value="">TT</mat-option>
                                <mat-option *ngFor="let gt of geburtstagdata" [value]="gt">{{gt}}</mat-option>
                            </mat-select>
                            <mat-label multilang>Geburtstag</mat-label>
                            <mat-error multilang>Geburtstag (Pflichtfeld)</mat-error>
                        </mat-form-field>
                        <!--Monat-->
                        <mat-form-field appearance="fill" color="primary" style="width: 32%;">
                            <mat-select required [formControlName]="prs + '_monat'">
                                <mat-option value="">MM</mat-option>
                                <mat-option *ngFor="let gt of monatdata" [value]="gt">{{gt}}</mat-option>
                            </mat-select>
                            <mat-label multilang>Monat</mat-label>
                            <mat-error multilang>Monat (Pflichtfeld)</mat-error>
                        </mat-form-field>
                        <!--Jahr-->
                        <mat-form-field appearance="fill" color="primary" style="width: 32%;">
                            <mat-select required [formControlName]="prs + '_jahr'">
                                <mat-option value="">JJJJ</mat-option>
                                <ng-container
                                    *ngIf="travelersForm.controls[prs + '_anrede']?.value === 'H' else allDatum">
                                    <mat-option *ngFor="let gt of jahrdata" [value]="gt">
                                        {{gt}}</mat-option>
                                </ng-container>
                                <ng-template #allDatum>
                                    <mat-option *ngFor="let gt of jahrdata" [value]="gt">{{gt}}</mat-option>
                                </ng-template>
                            </mat-select>
                            <mat-label multilang>Jahr</mat-label>
                            <mat-error multilang>Jahr (Pflichtfeld)</mat-error>
                        </mat-form-field>
                    </div>
                    <!--end Geburts-->

                    <!--Nationalität-->
                    <div style="display: flex;padding-top: .2rem;">
                        <mat-form-field appearance="fill" color="primary">
                            <mat-select required [formControlName]="prs + '_nat'"
                                (selectionChange)="getCountryNameFromCode($event, prs)">
                                <mat-option [value]="'de'">Deutschland</mat-option>
                                <mat-option [value]="'at'">Österreich</mat-option>
                                <mat-option [value]="'ch'">Schweiz</mat-option>
                                <mat-divider></mat-divider>
                                <mat-option *ngFor="let cy of countryList" [value]="cy.code">{{cy.name}}
                                </mat-option>
                            </mat-select>
                            <mat-label multilang>Nationalität</mat-label>
                            <mat-error multilang>Nationalität (Pflichtfeld)</mat-error>
                        </mat-form-field>
                    </div>
                    <!--end Nationalität-->

                </ng-container>
            </div>
        </form>
    </ng-container>
</ng-template>

<ng-template #loading>
    <img style="width: 100%;height: 30px;" class="lazyload" src="../../../../../assets/images/loading.svg">
</ng-template>

<ng-template #checkMode>
    <div class="check-wrapper mt">
        <span multilang>{{profileForm.controls['anmelder_anrede'].value}}</span>
        <span multilang>{{profileForm.controls['anmelder_name'].value}}
            {{profileForm.controls['anmelder_vorname'].value}}</span>
        <span
            multilang>{{profileForm.controls['anmelder_geburtstag'].value}}.{{profileForm.controls['anmelder_monat'].value}}.{{profileForm.controls['anmelder_jahr'].value}}</span>
        <span multilang>{{profileForm.controls['anmelder_strasse'].value}}
            {{profileForm.controls['anmelder_hausnummer'].value}}</span>
        <span multilang>{{profileForm.controls['anmelder_plz'].value}}
            {{profileForm.controls['anmelder_wohnort'].value}}</span>
        <span multilang>{{profileForm.controls['anmelder_land_name'].value}}</span>
        <span multilang>{{profileForm.controls['anmelder_telefon'].value}}</span>
        <span multilang>{{profileForm.controls['anmelder_email'].value}}</span>
        <span multilang>{{profileForm.controls['anmelder_text'].value}}</span>
        <div class="mt mb5">
            <button class="btnC" (click)="sendLastStep(0)">ÄNDEREN</button>
        </div>
    </div>
    <mat-divider></mat-divider>
    <!--Reiseanmelder-->
    <div class="head-title mt">
        <!--Title-->
        <span multilang>
            Personendaten
        </span>
        <!--end Title-->
    </div>
    <!--Info section-->
    <div class="mt mb5">

        <span multilang>
            Bitte teilen Sie uns die Reiseteilnehmer mit.
            Die Namen des Reisenden müssen exakt mit dem amtlichen Lichtbildausweis übereinstimmen.
        </span>
    </div>
    <!--end Info section-->

    <ng-container *ngFor="let prs of forms;let k=index">
        <div style="display: flex;padding: .5rem;background-color: #d1e7dd;margin-left: -1rem;margin-right: -1rem;">
            <span multilang>
                Reiseteilnehmer {{prs}}.
            </span>
        </div>

        <div class="check-wrapper mt">
            <span multilang>{{travelersForm.controls[prs + '_anrede'].value}}</span>
            <span multilang>{{travelersForm.controls[prs + '_name'].value}} {{travelersForm.controls[prs +
                '_vorname'].value}}</span>
            <span multilang>{{travelersForm.controls[prs + '_geburtstag'].value}}.{{travelersForm.controls[prs
                +'_monat'].value}}.{{travelersForm.controls[prs + '_jahr'].value}}</span>
            <span multilang>{{travelersForm.controls[prs + '_land_name'].value}}</span>
            <div class="mt">
                <button class="btnC" (click)="sendLastStep(0)">ÄNDEREN</button>
            </div>
        </div>
    </ng-container>
</ng-template>